<template>
  <div class="rate-star">
    <table>
      <tr>
        <td v-for="(num,index) in 5">
          <a class="rate-off rate-off2" :class="selected[index]?'rate-on rate-on2':''" @click="handleRate(index)"></a>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props:{
    content: Object
  },
  data() {
    return {
      selected:[false, false, false, false, false]
    }
  },
  methods:{
    handleRate: function(num) {
      let self = this
      self.selected.map(function(item,index){
        if(index<=num){
          self.$set(self.selected,index,true)
        }else{
          self.$set(self.selected,index,false)
        }
      })
      self.$emit('listenToChildEvent',num+1)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .rate-star
    display:inline-block
    margin-left:0.2rem
    .rate-off
      width: 21px;
      height: 21px;
      text-decoration: none;
      border-radius: 30px;
      color: #333;
      border: 1px solid #cacece;
      cursor: default;
      display: inline-block;
      background: #fafafa;
      line-height: 19px;
      text-align: center;
    .rate-on
      background-color: #53a4f4 !important;
      border: 1px solid #53a4f4;
      position: relative;
      color: #fff;
    .rate-on2
      background: url(../images/wjxstar.png) !important;
      background-position: 0 -28px !important;
    .rate-off2
      background: url(../images/wjxstar.png);
      border-radius: 0;
      box-shadow: none;
      border: 0;
      padding: 2px;
</style>
